import React, { useCallback, forwardRef, useRef, useImperativeHandle, useState } from 'react';
import { Input } from 'semantic-ui-react';

// eslint-disable-next-line flowtype/no-types-missing-file-annotation
type Props = {
  onHasValidationCode: (smsCode: string) => void,
  type?: string,
  className: string,
};

// eslint-disable-next-line flowtype/no-types-missing-file-annotation
const ValidationCodeInputComp = ({ onHasValidationCode, type = 'text', className, ...other }: Props, ref) => {
  const inputRef = useRef();
  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current.focus();
    },
  }));

  const [value, setValue] = useState('');

  const handleInputValue = useCallback(
    (event) => {
      setValue(event.target.value);
      if (onHasValidationCode && event.target.value !== '') {
        onHasValidationCode(event.target.value);
      }
    },
    [setValue, value]
  );

  return <Input className={className} type={type} value={value} onChange={handleInputValue} {...other} />;
};
export default forwardRef(ValidationCodeInputComp);
